// Module
var code = "<st-progressbar ng-if=\"!Model.isReady\" size=\"96\" layout=\"column\" layout-align=\"center center\" flex></st-progressbar> <main ng-if=\"Model.isReady\" class=\"form-page\"> <st-account-personalization account=\"CurrentAccount\" on-finished=\"saveAccount(data)\"></st-account-personalization> </main> ";
// Exports
module.exports = code;